import * as React from 'react';
import { BiLogger } from './bi-logger';

export interface InjectedBiLoggerProps {
  logger: BiLogger;
}

let logger: BiLogger;

export class LoggerProvider extends React.Component<{ msid: string }> {
  render() {
    logger = new BiLogger(this.props.msid);
    return this.props.children;
  }
}

export const provideLogger: <PropTypes extends {}>(component: React.ComponentType<PropTypes & InjectedBiLoggerProps>) => React.ComponentType<PropTypes> =
  (Component) => (props) => {return <Component logger={logger} {...props}/>;
};
